// extracted by mini-css-extract-plugin
export default {"wrapper":"ObjectNotFound_wrapper__s2lrJ","content":"ObjectNotFound_content__4wpUj","text_wrapper":"ObjectNotFound_text_wrapper__x9yf7","logo":"ObjectNotFound_logo__4dyVu"};